import { render } from "./AstVertretungsberechtigteModalCreateOrUpdate.pug?vue&type=template&id=182032e1&lang=pug"
import script from "./AstVertretungsberechtigteModalCreateOrUpdate.js?vue&type=script&lang=js"
export * from "./AstVertretungsberechtigteModalCreateOrUpdate.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__